export const enCron = {
	title: "Cron Jobs",
	subtitle: "Here you can find all your cron jobs",
	search: "Search for cron job",
	name: "Name",
	status: "Status",
	recordId: "Record ID",
	recordName: "Record Name",
	priority: "Priority",
	nextExecution: "Next Execution",
	startedAt: "Started At",
};
